import Home from './pages/Home';
import Register from './pages/Register';
import Start from './pages/Start';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './utils/scrollToTop';
import { Wrapper } from './components/helper/Wrapper';
// import './App.scss';

function App() {
  return (
    <>
      <Wrapper>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/start" element={<Start />} />
          <Route path="/register" element={<Register />} />
        </Routes>
      </Wrapper>
    </>
  );
}

export default App;
